import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { WorkbasketInput, WorkbasketInputs } from '../../domain';
import { AbstractAppConfig } from '../../../app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorService } from '../http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class WorkbasketInputFilterService {
  public static readonly V2_MEDIATYPE_WORKBASKET_INPUT_DETAILS =
    'application/vnd.uk.gov.hmcts.ccd-data-store-api.ui-workbasket-input-details.v2+json;charset=UTF-8';
  public static readonly QC_V2_MEDIATYPE_WORKBASKET_INPUT_DETAILS =
    'application/vnd.app.quickcase.store.data.api.ui-workbasket-input-details.v2+json;charset=UTF-8';

  private currentJurisdiction: string;
  private currentCaseType: string;

  constructor(private httpClient: HttpClient, private appConfig: AbstractAppConfig, private errorService: HttpErrorService) {
  }

  getWorkbasketInputs(jurisdictionId: string, caseTypeId: string): Observable<WorkbasketInput[]> {
    let url = this.getWorkbasketInputUrl(caseTypeId);
    let headers = new HttpHeaders({
      'Accept': [
        WorkbasketInputFilterService.V2_MEDIATYPE_WORKBASKET_INPUT_DETAILS,
        WorkbasketInputFilterService.QC_V2_MEDIATYPE_WORKBASKET_INPUT_DETAILS
      ],
    });
    this.currentJurisdiction = jurisdictionId;
    this.currentCaseType = caseTypeId;
    return this.httpClient
      .get<WorkbasketInputs>(url, {headers})
      .pipe(
        map(response => {
          let workbasketInputs = response.workbasketInputs;
          if (this.isDataValid(jurisdictionId, caseTypeId)) {
            workbasketInputs.forEach(item => {
              item.field.label = item.label;
            });
          } else {
            throw new Error('Response expired');
          }
          return workbasketInputs;
        }),
        catchError(error => {
          this.errorService.setError(error);
          return throwError(error);
        })
      );
  }

  private getWorkbasketInputUrl(caseTypeId: string): string {
    return `${this.appConfig.getCaseDataUrl()}/internal/case-types/${caseTypeId}/work-basket-inputs`;
  }

  isDataValid(jurisdictionId: string, caseTypeId: string): boolean {
    return this.currentJurisdiction === jurisdictionId && this.currentCaseType === caseTypeId
  }
}
